import { useNavigation } from '@/navigation/NavigationContex.ts';

/*
  If navigator.canShare is not available we skip the slide
 */
export const useShareOrRedirect = () => {
  const { next } = useNavigation();
  if (!navigator.canShare) {
    // SetTimeout required because we still have old "useState"'s with callbacks
    // fumbeling around in the code, producing errors
    setTimeout(next, 200);
  }
};
